import { Select } from "@molecules"

import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"

import { SCHEDULE_HORIZON_OPTIONS } from "@constants/scheduleHorizon"

import styles from "./ScheduleHorizonControl.module.scss"
import { ScheduleHorizonControlProps } from "./ScheduleHorizonControl.types"

export default function ScheduleHorizonControl(props: ScheduleHorizonControlProps) {
    const { isVisible } = props

    const { scheduleHorizon, setScheduleHorizon } = useObjectsView()

    const selectedOption = SCHEDULE_HORIZON_OPTIONS.find((option) => option.value === scheduleHorizon)

    return (
        <div className={styles.base}>
            <Select.Root>
                <Select.Input
                    isControlled={false}
                    placeholder="Select schedule horizon"
                    className={styles.horizonSelect}
                    isTabbable={isVisible}
                    selectedItem={
                        selectedOption ? { value: selectedOption.value, label: selectedOption.label } : undefined
                    }
                    size="sm"
                />
                <Select.Viewport>
                    <Select.List title="Schedule horizon" className={styles.horizonSelect}>
                        <Select.ListGroup>
                            {SCHEDULE_HORIZON_OPTIONS.map((option) => (
                                <Select.ListItem
                                    variant="default"
                                    key={option.value}
                                    item={{ value: option.value, label: option.label }}
                                    onSelect={() => setScheduleHorizon(option.value)}
                                    isSelected={scheduleHorizon === option.value}
                                />
                            ))}
                        </Select.ListGroup>
                    </Select.List>
                </Select.Viewport>
            </Select.Root>
        </div>
    )
}
